var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 512",
    style: {
      enableBackground: "new 0 0 448 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148,288h-40c-6.6,0-12-5.4-12-12v-40c0-6.6,5.4-12,12-12h40c6.6,0,12,5.4,12,12v40 C160,282.6,154.6,288,148,288z M256,276v-40c0-6.6-5.4-12-12-12h-40c-6.6,0-12,5.4-12,12v40c0,6.6,5.4,12,12,12h40 C250.6,288,256,282.6,256,276z M352,276v-40c0-6.6-5.4-12-12-12h-40c-6.6,0-12,5.4-12,12v40c0,6.6,5.4,12,12,12h40 C346.6,288,352,282.6,352,276z M256,372v-40c0-6.6-5.4-12-12-12h-40c-6.6,0-12,5.4-12,12v40c0,6.6,5.4,12,12,12h40 C250.6,384,256,378.6,256,372z M160,372v-40c0-6.6-5.4-12-12-12h-40c-6.6,0-12,5.4-12,12v40c0,6.6,5.4,12,12,12h40 C154.6,384,160,378.6,160,372z M352,372v-40c0-6.6-5.4-12-12-12h-40c-6.6,0-12,5.4-12,12v40c0,6.6,5.4,12,12,12h40 C346.6,384,352,378.6,352,372z M448,112v352c0,26.5-21.5,48-48,48H48c-26.5,0-48-21.5-48-48V112c0-26.5,21.5-48,48-48h48V12 c0-6.6,5.4-12,12-12h40c6.6,0,12,5.4,12,12v52h128V12c0-6.6,5.4-12,12-12h40c6.6,0,12,5.4,12,12v52h48C426.5,64,448,85.5,448,112z  M400,458V160H48v298c0,3.3,2.7,6,6,6h340C397.3,464,400,461.3,400,458z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.2298ca4971964ee4a87a42e82d6c535d.svg";
export { ForwardRef as ReactComponent };